import {connect} from 'react-redux';
import {Trash as Component} from './Trash';
import {
  createTrash,
  trashOpen
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("trash") &&
     state.notebook.protocolSection.scene.apparatus.trash.some(
       trash => trash.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.trash[ownProps.id-1].type,
      open: state.notebook.protocolSection.scene.apparatus.trash[ownProps.id-1].open,
      altText: state.notebook.protocolSection.scene.apparatus.trash[ownProps.id-1].altText
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createTrash: (data) => {
      dispatch(createTrash(data))
    },
    trashOpen: (data) => {
      dispatch(trashOpen(data))
    }
  };
}

export const Trash = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
